import * as React from 'react';

import CustomTestimonialItem from 'bundles/unified-description-page-common/components/modules/testimonials/CustomTestimonialItem';
import TestimonialItem from 'bundles/unified-description-page-common/components/modules/testimonials/TestimonialItem';
import TestimonialsModule from 'bundles/unified-description-page-common/components/modules/testimonials/TestimonialsModule';
import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';
import getTestimonials from 'bundles/unified-description-page-common/data/mockTestimonials';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';
import type { EnterpriseSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseSpecializationPageQuery';
import getProductTitle from 'bundles/unified-description-page-common/utils/getProductTitle';

import _t from 'i18n!nls/xdp';

type Props = {
  pageData:
    | ConsumerSpecializationPageFieldsFragment
    | EnterpriseSpecializationPageFieldsFragment
    | ConsumerCoursePageFieldsFragment
    | EnterpriseCoursePageFieldsFragment;
};

const TestimonialsModuleRenderer = ({ pageData }: Props) => {
  const hasCustomTestimonials = pageData.testimonials && pageData.testimonials.length > 0;
  const { navigationIdMap } = usePageInfo();

  return (
    <TestimonialsModule
      anchorId={navigationIdMap?.TESTIMONIALS}
      title={_t('Why people choose Coursera for their career')}
      testimonialItems={
        hasCustomTestimonials && pageData.testimonials
          ? pageData.testimonials.map((testimonial, index) => (
              <CustomTestimonialItem
                {...testimonial}
                productName={getProductTitle(pageData.name)}
                key={testimonial.authorName}
                trackingIndex={index}
              />
            ))
          : getTestimonials().map((testimonial, index) => (
              <TestimonialItem {...testimonial} key={testimonial.name} trackingIndex={index} />
            ))
      }
      slidesToShow={hasCustomTestimonials ? 1 : 2}
    />
  );
};

export default TestimonialsModuleRenderer;
